define.alias("shared/components/shared/ui/switcher", "preview-grid/components/shared/ui/switcher");